__turbopack_context__.v({
  "menuBackdrop": "R0BCra_menuBackdrop",
  "menuOpenMobile": "R0BCra_menuOpenMobile",
  "menuPanel": "R0BCra_menuPanel",
  "styleGuideContainer": "R0BCra_styleGuideContainer",
  "styleGuideContent": "R0BCra_styleGuideContent",
  "styleGuideHeader": "R0BCra_styleGuideHeader",
  "styleGuideMenu": "R0BCra_styleGuideMenu",
  "styleGuidePage": "R0BCra_styleGuidePage",
});
